import { Task } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockCandidateTasks: Task[] = [
  {
    id: '1',
    name: 'Official details',
    dueByDate: '2025-05-26T00:00:00.000Z',
    status: 'todo',
    createdAt: '2025-05-26T00:00:00.000Z',
    type: 'review',
    formId: '1',
    audience: 'partner',
    assignee: {
      email: 'test@test.com',
      accountId: '1'
    }
  },
  {
    id: '2',
    name: 'Previous grants',
    dueByDate: '2035-10-26T00:00:00.000Z',
    status: 'todo',
    createdAt: '2025-05-26T00:00:00.000Z',
    type: 'review',
    formId: '2',
    audience: 'partner',
    assignee: {
      email: 'test@test.com',
      accountId: '1'
    }
  },
  {
    id: '3',
    name: 'Bank details',
    dueByDate: '2025-05-26T00:00:00.000Z',
    status: 'done',
    createdAt: '2025-05-26T00:00:00.000Z',
    completedAt: '2025-05-26T00:00:00.000Z',
    type: 'bank_details',
    formId: undefined,
    audience: 'partner',
    assignee: {
      email: 'test@test.com',
      accountId: '1'
    }
  },
  {
    id: '4',
    name: 'Cancelled task',
    dueByDate: '2025-05-26T00:00:00.000Z',
    status: 'cancelled',
    createdAt: '2025-05-26T00:00:00.000Z',
    type: 'review',
    formId: '3',
    audience: 'partner',
    assignee: {
      email: 'test@test.com',
      accountId: '1'
    }
  }
]
